import "./WeekdayStatus.scss"

import classNames from "classnames"
import React from "react"

const WeekdayStatus = ({
  intervals = [],
  weekDay = { key: "", initialCharName: "" },
  setTooltip = () => {},
  closeTooltip = () => {},
  tt = () => {},
}) => {
  function formatTimeToAMPM(time) {
    const options = {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
      hourCycle: "h12",
    }
    return new Date(`2000-01-01T${time}`).toLocaleString("en-US", options).toLowerCase()
  }

  function getTooltipText() {
    return intervals
      .map(
        interval =>
          `${formatTimeToAMPM(interval.startTime)} - ${formatTimeToAMPM(interval.endTime)}`,
      )
      .join("\n")
  }

  const intervalsLengthForCurrentDay = intervals?.length
  const dayClassName = classNames("weekday-status", {
    "weekday-status--inactive": !intervalsLengthForCurrentDay,
  })

  return (
    <span
      key={weekDay.key}
      className={dayClassName}
      onMouseEnter={e => {
        if (intervalsLengthForCurrentDay) {
          setTooltip({
            event: e,
            text: getTooltipText(),
            caretBottom: true,
            alignItemAbove: true,
          })
        }
      }}
      onMouseLeave={() => {
        if (intervalsLengthForCurrentDay) {
          closeTooltip()
        }
      }}
    >
      {tt(weekDay.initialCharName)}
    </span>
  )
}

// WeekdayStatus.propTypes = {
//   intervals: PropTypes.arrayOf(
//     PropTypes.shape({
//       startTime: PropTypes.string,
//       endTime: PropTypes.string,
//     }),
//   ),
//   weekDay: PropTypes.shape({
//     key: PropTypes.string,
//     initialCharName: PropTypes.string,
//   }),
//   setTooltip: PropTypes.func,
//   closeTooltip: PropTypes.func,
// }

export default WeekdayStatus
